import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-solucoes',
  templateUrl: './solucoes.component.html',
  styleUrls: ['./solucoes.component.scss']
})

export class SolucoesComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
